import AjaxClass from '@/ajax/index'
import SettingsService from '@/services/SettingsService'

export default class LogonService {
  ajax
  store

  constructor (store) {
    this.store = store
    this.ajax = new AjaxClass(store)
  }

  login (user, callback) {
    this.ajax.post('/login', {username: user.username, password: user.password}, (data) => {
      if (!data.requestError) {
        data.fromLogonService = true
        this.store.dispatch('login', data)
      }
      callback(data)
    })
  }

  logout () {
    this.store.dispatch('logout', {fromLogonService: true})
  }

  isAuthenticated () {
    return !!this.store.getters.getAccessToken
  }

  static refreshToken (ajax, store, then) {
    let formData = new FormData()
    formData.append('grant_type', 'refresh_token')
    formData.append('refresh_token', store.getters.getRefreshToken)
    ajax.post(SettingsService.apiUrl + '/oauth/access_token', formData, (data) => {
      store.dispatch('login', data)
      then()
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/LogonService.js